const items = [
  { icon: "ri-home-4-line", label: "Residential Architecture", detail: "Custom homes & additions" },
  { icon: "ri-building-line", label: "Multi-Family", detail: "Apartments & townhomes" },
  { icon: "ri-hotel-line", label: "Hospitality Design", detail: "Hotels & restaurants" },
  { icon: "ri-tools-line", label: "Renovation", detail: "Transform existing spaces" },
  { icon: "ri-map-pin-2-line", label: "Santa Monica", detail: "Los Angeles County" },
  { icon: "ri-award-line", label: "15+ Years", detail: "Design excellence" },
];

export default function TrustBar() {
  return (
    <section className="bg-[#111111] py-8 overflow-hidden">
      <div className="px-8 lg:px-14">
        <div className="flex flex-nowrap lg:flex-wrap gap-0 overflow-x-auto lg:overflow-visible scrollbar-hide">
          {items.map((item, i) => (
            <div
              key={i}
              className="flex-none lg:flex-1 flex items-center gap-3 px-6 py-4 border-r border-white/10 last:border-r-0 first:pl-0 last:pr-0 min-w-[180px]"
            >
              <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                <i className={`${item.icon} text-white/50 text-lg`} />
              </div>
              <div>
                <p className="text-white text-xs font-medium tracking-wide whitespace-nowrap">{item.label}</p>
                <p className="text-white/40 text-xs font-light">{item.detail}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
